<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <div class="pa-4">
        <div>
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields.title" label="Name" />
        </div>
        <div>
          <label class="label-input">Content</label>
          <div class="header-card mb-4">
            <div class="d-flex align-center gap-3 mb-2">
              <label style="padding-right: 12px;" for="show-header">Header</label>
              <input type="checkbox" v-model="fields['header'].show" id="show-header" />
            </div>
            <ckeditor :editor="editor" v-model="fields['header'].content" :config="editorConfig" />
          </div>
          <div style="margin-bottom: 20px">
            <div class="d-flex align-center gap-3">
              <input
                type="color"
                name="card-container"
                style="width: 40px; height: 40px; margin-right: 12px"
                :value="fields['card-container']"
                @change="handleChangeCardContainerBackground"
              />
              <v-text-field v-model="fields['card-container']" label="Background Color" />
            </div>
          </div>
          <div>
            <label class="label-input" style="margin-bottom: 0">Button Play Video</label>
            <div style="margin-bottom: 20px">
              <v-row>
                <v-col cols="12" md="6">
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="btnPlayVideo-background"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['btnPlayVideo']['background']"
                      @change="handleChangeBtnPlayVideoBackground"
                    />
                    <v-text-field v-model="fields['btnPlayVideo']['background']" label="Background Color" />
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="btnPlayVideo-text"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['btnPlayVideo']['color']"
                      @change="handleChangeBtnPlayVideoColor"
                    />
                    <v-text-field v-model="fields['btnPlayVideo']['color']" label="Background Color" />
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
          <div>
            <div class="d-flex justify-space-between align-center">
              <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
                <label class="label-input" style="margin-bottom: 0">Videos</label>
              </div>
              <v-btn small text color="primary" @click="handleAddVideo">
                <v-icon size="16">mdi-plus</v-icon>
                <span>Add Video</span>
              </v-btn>
            </div>
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, i) in fields['listItem']" :key="i">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <span>Video {{ i + 1 }}</span>
                    <v-btn icon @click.stop="handleRemoveVideo(i)">
                      <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="d-flex align-center gap-6">
                    <v-text-field v-model="item.video" label="Video URL" />
                    <v-btn @click="handlePreviewVideo(i)" text color="primary">
                      <v-icon>mdi-reload</v-icon> Reload
                    </v-btn>
                  </div>
                  <div class="video-wrapper">
                    <div class="wrap-video">
                      <video width="100%" height="auto" autoplay muted loop playsinline :ref="'videoPlayer'">
                        <source data-attribute="card-video" type="video/mp4" :src="item.video" />
                      </video>
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </div>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '../common/html/update';
export default {
  name: 'CardVideoSlider',
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: '',
        'card-container': '',
        header: {
          show: false,
          content: '',
        },
        btnPlayVideo: {
          background: '#000000',
          color: '#FFFFFF',
        },
        listItem: [],
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleChangeBtnPlayVideoBackground(event) {
      this.fields['btnPlayVideo']['background'] = event.target.value;
    },
    handleChangeBtnPlayVideoColor(event) {
      this.fields['btnPlayVideo']['color'] = event.target.value;
    },
    handlePreviewVideo(index) {
      const video = this.$refs.videoPlayer[index];
      video.load();
      video.play();
    },
    handleAddVideo() {
      this.fields['listItem'].push({
        video:
          'https://hizoo.co/cdn/shop/videos/c/vp/e1cad5ac90d64cc9ae31a3f1efcc6915/e1cad5ac90d64cc9ae31a3f1efcc6915.HD-720p-1.6Mbps-57703554.mp4?v=0',
      });
    },
    handleRemoveVideo(index) {
      this.fields['listItem'].splice(index, 1);
    },
    handleChangeCardContainerBackground(event) {
      this.fields['card-container'] = event.target.value;
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionCardVideoSlider(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.ck-editor__editable_inline {
  min-height: 300px;
}
.ck-editor__editable {
  min-height: 300px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.video-wrapper {
  background: rgba(0, 0, 0, 0.767);
  .wrap-video {
    max-width: 300px;
    margin: 0 auto;
    video {
      display: block;
      width: 100%;
      height: auto;
    }
  }
}
</style>
